"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynaNodeDebuggerLog = function (global, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.commandLength, commandLength = _c === void 0 ? 40 : _c, _d = _b.fromLength, fromLength = _d === void 0 ? 30 : _d, _e = _b.toLength, toLength = _e === void 0 ? 30 : _e, _f = _b.console, consoleMethod = _f === void 0 ? 'debug' : _f, _g = _b.globalVarName, globalVarName = _g === void 0 ? '_debug_dynaNodeDebugger' : _g, _h = _b.filter, filter = _h === void 0 ? function () { return true; } : _h, _j = _b.onTransaction, onTransaction = _j === void 0 ? function () { return undefined; } : _j;
    console.debug('dynaNodeDebugger is enabled');
    var log = [];
    global[globalVarName] = {
        log: log,
        get list() {
            log.forEach(function (l) { return console.log(l.desc); });
            return undefined;
        },
    };
    global._debug_dynaNode_monitorTransactions = function (debugTransactionInfo) {
        if (!filter(debugTransactionInfo))
            return;
        var now = new Date;
        var direction = debugTransactionInfo.direction, message = debugTransactionInfo.message;
        var desc = [
            text({ text: log.length.toString(), minLength: 5, trailing: 'start' }),
            text({ text: now.toLocaleTimeString(), minLength: 5, trailing: 'start' }),
            text({ text: direction || '-', minLength: 3 }),
            text({ text: message.from || '-', minLength: fromLength, trailing: 'end', ellipsis: true }),
            '->',
            text({ text: message.to || '-', minLength: toLength, trailing: 'end', ellipsis: true }),
            text({ text: message.command || '-', minLength: commandLength, trailing: 'end', ellipsis: true }),
        ].join(' ');
        log.push({
            desc: desc,
            message: message,
            date: now,
        });
        if (consoleMethod !== 'none')
            console[consoleMethod](desc);
        onTransaction(debugTransactionInfo);
    };
};
var text = function (_a) {
    var text = _a.text, minLength = _a.minLength, _b = _a.trailing, trailing = _b === void 0 ? 'end' : _b, _c = _a.trailingChar, trailingChar = _c === void 0 ? ' ' : _c, _d = _a.ellipsis, ellipsis = _d === void 0 ? false : _d;
    var output = text;
    while (output.length < minLength) {
        if (trailing === "start")
            output = trailingChar + output;
        if (trailing === "end")
            output += trailingChar;
    }
    if (ellipsis && output.length > minLength) {
        output = output.substr(0, minLength - 1) + '…';
    }
    return output;
};
//# sourceMappingURL=dynaNodeDebuggerLog.js.map